import i18n from "@/i18n";
import { format } from "date-fns";
import { formatInTimeZone, toZonedTime } from "date-fns-tz";
import { enGB } from "date-fns/locale";

const locales = { en: enGB };

export const getLocale = () => {
    switch (i18n.global.locale.value) {
        default:
            return locales.en;
    }
};

export const formatDate = (date: string | Date, dateFormat: string, timeZone: string | undefined = undefined): string => {
    return date ? formatInTimeZone(new Date(date), timeZone ?? "Europe/Dublin", dateFormat, { locale: getLocale() }) : "";
};

export const YYYYMMDD = (date: Date): string => {
    return formatDate(date, "yyyy-MM-dd");
};

export const HHMM = (date: Date): string => {
    return formatDate(date, "HH:mm");
};

export const YYYY = (date: Date): string => {
    return formatDate(date, "yyyy");
};

export const MM = (date: Date): string => {
    return formatDate(date, "MM");
};

export const DD = (date: Date): string => {
    return formatDate(date, "dd");
};

export const dateAndTime = (date: Date): string => {
    return formatDate(date, "yyyy-MM-dd HH:mm");
};

export const monthName = (date: Date, length?: number): string => {
    return length ? format(date, "LLLL").substring(0, length) : format(new Date(date), "LLLL");
};

export const dayOfWeekName = (date: Date, length?: number): string => {
    return length ? format(date, "EEEE").substring(0, length) : format(new Date(date), "EEEE");
};

export const fullDate = (date: Date): string => {
    return formatDate(date, "EEEE do LLLL");
};

export const dayOrdial = (date: Date): string => {
    return format(date, "do");
};

export const startOfToday = (timeZone: string = "Europe/Dublin") => {
    const now = new Date();

    const zonedNow = toZonedTime(now, timeZone);
    return zonedNow;
};
